import { Component, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';

import { NavigationConfirmationDialogComponent } from '../dialogs/navigation-confirmation-dialog/navigation-confirmation-dialog.component';

interface FormComponent extends Component {
  isFormDirty: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FormGuard {
  constructor(public dialog: MatDialog) {}

  canDeactivate(component: FormComponent): Observable<boolean> {
    if (component.isFormDirty) {
      const confirmDialogRef = this.dialog.open(NavigationConfirmationDialogComponent, {
        autoFocus: false,
      });

      return confirmDialogRef.afterClosed();
    }

    return of(true);
  }
}
